export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  }
  
  export async function downscaleImageFile(file, maxDim = 2048, mime = "image/webp", quality = 0.92) {
    const bitmap = await createImageBitmap(file);
  
    const { width, height } = bitmap;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    const outW = Math.max(1, Math.round(width * scale));
    const outH = Math.max(1, Math.round(height * scale));
  
    const canvas = document.createElement("canvas");
    canvas.width = outW;
    canvas.height = outH;
  
    const ctx = canvas.getContext("2d", { alpha: true });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(bitmap, 0, 0, outW, outH);
  
    const blob = await new Promise((res) => canvas.toBlob(res, mime, quality));
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".webp", { type: mime });
  }